<script setup lang="ts">
defineOptions({
  inheritAttrs: false
})

withDefaults(
  defineProps<{
    label: string
    tone?: "success" | "warning" | "danger" | "neutral"
    tooltip?: string
  }>(),
  {
    tone: "neutral",
    tooltip: ""
  }
)
</script>

<template>
  <UTooltip
    v-if="tooltip"
    :text="tooltip"
    :ui="{ content: 'dashboard-tooltip-content', text: 'dashboard-tooltip-text' }"
  >
    <UBadge
      v-bind="$attrs"
      color="neutral"
      variant="soft"
      size="xs"
      class="dashboard-badge dashboard-mono"
      :class="`dashboard-badge--${tone}`"
    >
      {{ label }}
    </UBadge>
  </UTooltip>
  <UBadge
    v-else
    v-bind="$attrs"
    color="neutral"
    variant="soft"
    size="xs"
    class="dashboard-badge dashboard-mono"
    :class="`dashboard-badge--${tone}`"
  >
    {{ label }}
  </UBadge>
</template>
